import { clamp, tone, label } from './shared';
const TITLES = ['One quick search', 'Untitled document', 'Where is the music?', 'You have won!', 'Reply all (38)', 'Another dashboard', 'Lunch options', 'Meeting about meetings', 'Download (7).pdf', 'Is the internet down?', 'Sales follow-up #12', 'New tab'];
export class Tabageddon {
  constructor(random, finish) {
    this.random = random; this.finish = finish; this.score = 0; this.level = 1; this.time = 0;
    this.ram = 15; this.combo = 0; this.bestCombo = 0; this.closed = 0; this.selected = 0; this.mistakes = 0;
    this.tabs = Array(12).fill(null); this.pinned = Math.floor(random() * 12); this.tabs[this.pinned] = { pinned: true, title: 'Actual work', age: 0 };
    this.spawnTimer = 1.2; this.restoreTimer = 22; this.message = 'Keep the starred work tab. Close everything else.'; this.messageTime = 4;
    this.lastClose = -10; this.over = false; this.flash = 0; this.protect = 0;
    for (let i = 0; i < 3; i++) this.spawn();
  }
  spawn() {
    const free = this.tabs.map((t, i) => t ? -1 : i).filter(i => i >= 0);
    if (!free.length) { this.ram += 7; return; }
    const slot = free[Math.floor(this.random() * free.length)];
    this.tabs[slot] = { title: TITLES[Math.floor(this.random() * TITLES.length)], age: 0, noisy: this.random() < .2 };
    this.ram += 2;
  }
  point(x, y) {
    const col = Math.floor((x - 18) / 190), row = Math.floor((y - 170) / 115);
    if (x < 18 || x > 582 || y < 170 || y > 616 || col > 2 || row > 3) return;
    if ((x - 18) % 190 > 184 || (y - 170) % 115 > 101) return;
    this.selected = row * 3 + col; this.close(this.selected);
  }
  key(key) {
    if (key === 'ArrowLeft' || key.toLowerCase() === 'a') this.selected = (this.selected + 11) % 12;
    if (key === 'ArrowRight' || key.toLowerCase() === 'd') this.selected = (this.selected + 1) % 12;
    if (key === 'ArrowUp' || key.toLowerCase() === 'w') this.selected = (this.selected + 9) % 12;
    if (key === 'ArrowDown' || key.toLowerCase() === 's') this.selected = (this.selected + 3) % 12;
    if (key === ' ' || key === 'Enter') this.close(this.selected);
  }
  close(index) {
    if (this.over) return;
    const tab = this.tabs[index]; if (!tab) return;
    if (tab.pinned) {
      if (this.protect > 0) return;
      this.ram = Math.min(100, this.ram + 18); this.mistakes++; this.combo = 0; this.flash = .3; this.protect = 1;
      this.message = 'That was the work tab. Restored. +18 RAM.'; this.messageTime = 2.5; tone('hurt'); return;
    }
    this.combo = this.time - this.lastClose < 2 ? this.combo + 1 : 1; this.lastClose = this.time; this.bestCombo = Math.max(this.combo, this.bestCombo);
    this.score += 50 * Math.min(5, Math.ceil(this.combo / 3)); this.closed++; this.tabs[index] = null;
    this.ram = Math.max(0, this.ram - (tab.noisy ? 10 : 6)); tone(tab.noisy ? 'collect' : 'clear');
    if (this.closed % 15 === 0) {
      this.level++; this.score += 250; this.ram = Math.max(0, this.ram - 10);
      this.message = `Shift ${this.level} • +250 • Ed is opening more tabs.`; this.messageTime = 3; tone('wave');
    }
  }
  update(dt) {
    if (this.over) return;
    this.time += dt; this.messageTime -= dt; this.flash -= dt; this.protect -= dt;
    let pressure = .65 + Math.min(2, this.level * .1);
    this.tabs.forEach(t => { if (t && !t.pinned) { t.age += dt; pressure += t.noisy ? 1.65 : .72; } });
    this.ram += dt * pressure;
    this.spawnTimer -= dt; this.restoreTimer -= dt;
    if (this.spawnTimer <= 0) { this.spawn(); this.spawnTimer = Math.max(.32, 1.5 - this.level * .105); }
    if (this.restoreTimer <= 0) {
      this.spawn(); this.spawn(); this.spawn();
      this.message = 'Restore previous session? Ed already clicked yes.'; this.messageTime = 3.5; this.restoreTimer = 22; tone('wave');
    }
    if (this.ram >= 100) {
      this.ram = 100; this.over = true;
      this.finish({ score: this.score, level: this.level, detail: `${this.closed} tabs closed • ${Math.floor(this.time)} seconds • best combo ${this.bestCombo}`, achievement: this.closed >= 50 && !this.mistakes ? 'Work tab guardian' : this.bestCombo >= 15 ? 'Tab terminator' : 'Session restored' });
    }
  }
  draw(ctx, reduced) {
    ctx.fillStyle = '#101a29'; ctx.fillRect(0, 0, 600, 700);
    ctx.fillStyle = '#213049'; ctx.fillRect(0, 0, 600, 52);
    label(ctx, String(this.score).padStart(6, '0'), 20, 34, 23); label(ctx, `SHIFT ${this.level}`, 580, 33, 18, '#b8c9e7', 'right');
    label(ctx, 'RAM', 20, 83, 17, '#b8c9e7'); label(ctx, `${Math.ceil(this.ram)} / 100`, 580, 83, 17, this.ram > 75 ? '#ff8598' : '#98edda', 'right');
    ctx.fillStyle = '#2b3b52'; ctx.fillRect(20, 96, 560, 17); ctx.fillStyle = this.ram > 75 ? '#ff6987' : '#6be2c4'; ctx.fillRect(20, 96, 560 * clamp(this.ram / 100, 0, 1), 17);
    label(ctx, this.combo > 1 ? `${this.combo} COMBO • ${Math.min(5, Math.ceil(this.combo / 3))}× POINTS` : 'Close junk. Protect ★ Actual work.', 20, 148, 17, '#ffdf96');
    for (let i = 0; i < 12; i++) {
      const x = 18 + i % 3 * 190, y = 170 + Math.floor(i / 3) * 115, t = this.tabs[i];
      ctx.fillStyle = t ? (t.pinned ? '#253e42' : '#d8e4f0') : '#182639'; ctx.fillRect(x, y, 184, 101);
      if (t) {
        ctx.fillStyle = t.pinned ? '#366665' : t.noisy ? '#b585ad' : '#aebfd6'; ctx.fillRect(x, y, 184, 26);
        label(ctx, t.pinned ? '★ PINNED' : t.noisy ? '♫ PLAYING AUDIO' : 'BROWSER TAB', x + 9, y + 18, 12, t.pinned ? '#c6fff1' : '#22324b');
        if (!t.pinned) label(ctx, '×', x + 172, y + 21, 25, '#25344d', 'right');
        const words = t.title.split(' '); let line = '', lines = [];
        words.forEach(word => { if ((line + word).length > 17) { lines.push(line); line = ''; } line += word + ' '; }); lines.push(line);
        lines.forEach((l, j) => label(ctx, l.trim(), x + 10, y + 51 + j * 18, 15, t.pinned ? '#d9fff4' : '#22324b'));
        label(ctx, t.pinned ? 'Do not close' : 'Tap to close', x + 10, y + 89, 12, t.pinned ? '#92cabc' : '#52647d');
      } else label(ctx, '+', x + 92, y + 59, 24, '#3f526b', 'center');
      if (i === this.selected) { ctx.strokeStyle = '#ffd784'; ctx.lineWidth = 3; ctx.strokeRect(x - 2, y - 2, 188, 105); }
    }
    const message = this.messageTime > 0 ? this.message : `${this.closed} tabs closed. ${Math.floor(this.time)}s without a browser crash.`;
    const words = message.split(' '); let line = '', lines = [];
    words.forEach(word => { if ((line + word).length > 49) { lines.push(line); line = ''; } line += word + ' '; }); lines.push(line);
    lines.forEach((l, i) => label(ctx, l.trim(), 300, 652 + i * 22, 17, '#c5d3e8', 'center'));
    if (this.flash > 0 && !reduced) { ctx.fillStyle = '#ff456522'; ctx.fillRect(0, 0, 600, 700); }
  }
}
